import { NewBankType } from '@features/branch-management/constants';
import { BankAccount } from 'types/account-detail';

const BankAccountOption = ({
  account
}: {
  account: BankAccount | NewBankType;
}) => (
  <div className="flex min-w-0 items-center gap-2">
    <img
      src={account.bank_logo}
      alt="Bank Logo"
      className="size-9 shrink-0 rounded-lg border border-grey10 object-contain"
    />
    <div className="flex min-w-0 flex-1 flex-col items-start text-left">
      <div className="w-full text-left text-sm font-medium leading-tight text-content">
        {account.bank_account_name}
      </div>
      <div className="w-full text-left text-xs leading-tight text-grey">
        {account.bank_account_number}
      </div>
    </div>
  </div>
);

export default BankAccountOption;
